import { ReactNode } from 'react';
import tw, { TwStyle } from 'twin.macro';

import { CheckMarkIcon } from '@icons/CheckMarkIcon';

const CheckboxWrapper = tw.button`flex items-center justify-center cursor-pointer`;
const StyledCheckbox = tw.div`w-[13px] h-[13px] min-w-[13px] min-h-[13px] border border-solid border-sec-2 rounded-sm flex items-center justify-center p-0`;

export const Checkbox = ({
  onChange,
  checked,
  title,
  children,
  className,
  checkboxStyles,
}: {
  onChange: () => void;
  checked: boolean;
  children?: ReactNode;
  title?: string;
  className?: string;
  checkboxStyles?: TwStyle;
}) => {
  return (
    <CheckboxWrapper onClick={onChange} title={title} className={className}>
      <StyledCheckbox css={[checked && tw`bg-accent-muted border-accent-muted`, checkboxStyles]}>
        {checked ? <CheckMarkIcon tw='stroke-neutral-background w-2 h-2' /> : ''}
      </StyledCheckbox>
      {children}
    </CheckboxWrapper>
  );
};
